import { VersionInfoHelperBase } from "abweb/dto/generated/com/abinitio/webcommons/abweb/util/VersionInfoHelperBase";

/**
 * A Helper class and TSOG Base class for the generated {@link VersionInfo} class. Following the pattern/nomenclature being
 * adopted by the AbSDK team, this both wraps and extends {@link VersionInfo}: extending so that it can be used anywhere
 * a {@link VersionInfo} can be used, and wrapping so that it can provide additional functionality. The additional functionality
 * in this case is the {@link supports} method.
 */
export class VersionInfoHelper extends VersionInfoHelperBase {
  static createVersionInfoHelper(compatibility, semanticVersionNumber, versionNumber) {
    const retVal = new VersionInfoHelper();
    retVal.initVersionInfoHelper(compatibility, semanticVersionNumber, versionNumber);
    return retVal;
  }
  constructor() {
    super();
  }
  supports(feature) {
    return this.compatibility.indexOf(feature) !== -1;
  }
}
//# sourceMappingURL=VersionInfoHelper.js.map
